import { $isLinkNode } from "@lexical/link";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import DOMPurify from "dompurify";
import {
  $getSelection,
  $isRangeSelection,
  CLICK_COMMAND,
  COMMAND_PRIORITY_LOW,
} from "lexical";
import { useEffect } from "react";

export function LinkClickPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      CLICK_COMMAND,
      (event) => {
        // Require Cmd (macOS) or Ctrl (Windows/Linux)
        if (!event.metaKey && !event.ctrlKey) {
          return false;
        }

        // Prevent the browser's default behavior of opening the link
        event.preventDefault();

        editor.getEditorState().read(() => {
          const selection = $getSelection();
          if (!$isRangeSelection(selection)) return;

          const node = selection.anchor.getNode();
          const linkNode = $isLinkNode(node)
            ? node
            : $isLinkNode(node.getParent())
              ? node.getParent()
              : null;

          if (!linkNode) return;

          const url = linkNode.getURL();
          const sanitizedUrl =
            DOMPurify.sanitize(url, { ALLOWED_URI_REGEXP: /^(https?|ftp):/ }) ||
            (() => {
              throw new Error("Invalid URL");
            })();

          window.open(sanitizedUrl, "_blank", "noopener,noreferrer");
        });

        return true; // stop Lexical's default handling
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor]);

  return null;
}
